import React from "react";

/** Renders a compact function label or electrical switch symbol above a device tag. */
export function C1_TagFunction({ x, y, color, label, framed = false, symbol = "power" }: {
  x: number;
  y: number;
  color: string;
  label?: string;
  framed?: boolean;
  symbol?: "power" | "contact";
}) {
  const scale = label === "2x LAN" || symbol === "contact" ? 0.7 : 0.8;
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`} pointerEvents="none">
      {label && framed && (
        <rect x={-4.8} y={-2.6} width={9.6} height={5.2} rx={0.4}
          fill="none" stroke={color} strokeWidth={0.35} />
      )}
      {label ? (
        <text x={0} y={0} fill={color} fontFamily="Inter, Arial, sans-serif" fontSize={4.1} fontWeight={label === "%" ? 600 : 400}
          textAnchor="middle" dominantBaseline="central" alignmentBaseline="central">{label}</text>
      ) : symbol === "contact" ? (
        <path d="M -3.5 1 H -1.3 L 1.2 -1.1 M 1.3 1 H 3.5"
          transform="scale(1.3225)"
          fill="none" stroke={color} strokeWidth={0.45} strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <g fill="none" stroke={color} strokeWidth={0.35} strokeLinecap="round">
          <circle cx={0} cy={0} r={1.7} />
          <line x1={0} y1={-2.3} x2={0} y2={0} />
        </g>
      )}
    </g>
  );
}
